/**
 * @desc 门店线索
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** page_no */
  page_no: number;
  /** page_size */
  page_size: number;
  /** store_code */
  store_code: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<
    defs.store.GeneralHttpResponse<Array<defs.store.StoreClueDTO>>
  >(`/storeapi/inner/page/store/clue`, {
    params,
    method: 'get',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<Array<defs.store.StoreClueDTO>>;
export default req;
